export default __webpack_public_path__ + "static/media/discover-and-orientate.febe7a5e.png";